import { createRouter, createWebHistory } from 'vue-router'
import { isUserSite, userLoginPath } from '@/helpers/userSite'

const routes = createRouter({
    history: createWebHistory(),
    routes: [
        {
            path: '/user-login',
            name: 'user-entry',
            component: () => import('@/components/auth/UserEntry.vue')
        },
        {
            path: '/login',
            component: () => import('@/components/auth/LoginComponent.vue')
        },
        {
            path: '/user-login/:whiteLabel',
            name: 'user-login',
            component: () => import('@/components/auth/UserLogin.vue')
        },

        {
            path: '/',
            name:'Dashboard',
            component: () => import('@/components/DashboardComponent.vue')
        },
        {
            path: '/chat-flow',
            component: () => import('@/components/chat-flow/ListComponent.vue')
        },
        {
            path: '/operators',
            component: () => import('@/components/operators/ListComponent.vue')
        },
        {
            path: '/operators/:status',
            component: () => import('@/components/operators/ListComponent.vue')
        },
        {
            props: true,
            path: '/operator-details/:item_id',
            component: () => import('@/components/operators/DetailComponent.vue')
        },
        {
            path: '/tickets',
            component: () => import('@/components/tickets/ListComponent.vue')
        },
        {
            path: '/whitelable',
            component: () => import('@/components/whitelables/ListComponent.vue')
        },
        {
            path: '/whitelable/:status',
            component: () => import('@/components/whitelables/ListComponent.vue')
        },
        {
            props: true,
            path: '/whitelable-details/:item_id',
            component: () => import('@/components/whitelables/DetailComponent.vue')
        },
        {
            path: '/agents',
            component: () => import('@/components/agents/ListComponent.vue')
        },
        {
            path: '/agents/:status',
            component: () => import('@/components/agents/ListComponent.vue')
        },
        {
            props: true,
            path: '/agent-details/:item_id',
            component: () => import('@/components/agents/DetailComponent.vue')
        },
        {
            path: '/chats/:user?',
            component: () => import('@/components/chats/ListComponent.vue')
        },
        {
            path: '/chat-requests',
            name: 'chatRequests',
            component: () => import('@/components/chatrequests/ListComponent.vue')
        },
        {
            path: '/auto-suggestions',
            component: () => import('@/components/autosuggestion/ListComponent.vue')
        },
        {
            path: '/theme-settings',
            component: () => import('@/components/themesetting/ListComponent.vue')
        },

        {
            path: '/support-chat/:token',
            name: 'support-chat',
            component: () => import('@/components/EndUserChatComponent.vue')
        },
        {
            path: '/support-chat-new/:token',
            name: 'support-chat-new',
            component: () => import('@/components/EndUserChatComponentNew.vue')
        },

        {
            path: '/user-chat-panel/:token?',
            name: 'user-chat-panel',
            component: () => import('@/components/EndUserChatComponentUpdate.vue'),
            beforeEnter: (to) => {
                const token = to.params.token || localStorage.getItem('end_user_token');
                if (token) {
                    return true;
                }
                const whiteLabel = localStorage.getItem('end_user_wl');
                if (!whiteLabel?.trim()) return { path: '/user-login' };
                return {
                    name: 'user-login',
                    params: { whiteLabel }
                };
            }
        },

        {
            props: true,
            path: '/reviews/:user_id?',
            component: () => import('@/components/reviews/ListComponent.vue')
        },
        {
            path: '/broadcasts',
            component: () => import('@/components/broadcasts/ListComponent.vue')
        },
        {
            path: '/groups-channels',
            component: () => import('@/components/spaces/ListComponent.vue')
        },
        {
            path: '/agent-chats/:adminid',
            component: () => import('@/components/chats/ListComponent.vue')
        },
        {
            path: '/profile',
            component: () => import('@/components/profile/Profile.vue')
        },
    ],
})

routes.beforeEach((to) => {
    if (!isUserSite()) {
        if (['user-login', 'user-entry'].includes(to.name)) {
            return { path: '/login', replace: true };
        }
        return true;
    }
    if (['user-login', 'user-entry', 'user-chat-panel'].includes(to.name)) return true;
    return { path: userLoginPath(), replace: true };
});

export default routes
